import {
  StyleSheet, FlatList, View, Dimensions, TouchableOpacity,
  Text, ActivityIndicator,
} from 'react-native';
import { Image } from 'expo-image';
import { useNavigation } from '@react-navigation/native';
import { useState, useEffect } from 'react';
import Entypo from '@expo/vector-icons/Entypo';
import { Character, PuzzleThemeCharacter } from '../data/types';
import { db } from '../data/database';
import { useTypedSelector } from '../redux/store';
import { PuzzleAPI } from '../data/puzzleApi';
import { PayTipModal } from '../components/pay/payTipModal';
import { PayAPI } from '../data/payApi';
import { useDispatch } from 'react-redux';

let { width } = Dimensions.get('window');
if(width > 460){ width = 460; }
const COLUMN_WIDTH = width / 2 - 10;

export default function HomeScreen() {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const [characters, setCharacters] = useState<PuzzleThemeCharacter[]>([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [nextCursor, setNextCursor] = useState<string | undefined>();
  const [error, setError] = useState<string | null>(null);
  const userCurrent = useTypedSelector((state) => state.userCurrent);

  const [checkPay, setCheckPay] = useState({
    coin: 50, index: 0, open: false, tips: "Unlock this image with coins"
  });

  const loadCharacters = async (refresh = false) => {
    // if (loading || (!hasMore && !refresh)) return;
    if(loading) return;
    await db.clearCharacterCache();
    if(!hasMore) return;
    setLoading(true);
    try {
      setError(null);
      
      if (refresh) {
        await db.clearCharacterCache();
        setCharacters([]);
        setNextCursor(undefined);
        setHasMore(true);
      } else {
        const cachedData = await db.getCachedCharacters();
        if (cachedData) {
          setCharacters(cachedData.characters);
          setNextCursor(cachedData.nextCursor);
          setHasMore(!!cachedData.nextCursor);
          return;
        }
      };

      // Get characters from Supabase via the API
      const charactersData = await PuzzleAPI.getPuzzleTheme();
      let list = charactersData?.list || [];

      handleRedata(list);
      setHasMore(false); // No pagination when using Supabase direct fetch
      await db.cacheCharacters(list);

      // Commented out previous code
      // try {
      //   const response = await CharacterAPI.fetchCharacters(nextCursor);
      //   // ...existing commented code...
      // } catch (apiError) {
      //   // ...existing commented code...
      // }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load characters');
    } finally {
      setLoading(false);
    }
  };

  const handleRedata = (themes: PuzzleThemeCharacter[])=>{
    let list = [...themes];
    let unlock_theme = userCurrent.unlock_theme || [];

    list.forEach((item, idx)=>{
      if(
        unlock_theme.includes(item.id) ||
        item.name === "free"
      ){
        item.disabled = false;
      }else{
        item.disabled = true;
      }
      item.price_num = parseInt(item.price);
    });
    setCharacters(list);
  };

  useEffect(() => {
    if(characters.length > 0){ handleRedata(characters); }
  }, [userCurrent]);

  // useEffect(() => {
  //   // getUserInfo();
  //   // loadCharacters();
  // }, []);

  const handleImagePress = (item: PuzzleThemeCharacter, index: number) => {
    // if(userCurrent.sub_list.includes(item.name)){
    //   navigation.navigate('Message', { character: item });
    // }else{
    // }
    if(item.disabled){
      setCheckPay({
        coin: item.price_num, index: index, open: true,
        tips: "Unlock this theme with coins"
      })
    }else{
      navigation.navigate('Detail', { character: item });
    };
    
  };

  const renderItem = ({ item, index }: { item: PuzzleThemeCharacter, index: number }) => (
    <View style={styles.card}>
      <TouchableOpacity
        style={styles.touchable}
        onPress={() => handleImagePress(item, index)}
      >
        <Image
          source={{ uri: item.role_img_url }}
          style={styles.image}
          blurRadius={ item.disabled ? 10 : 0 }
        />
        {item.disabled && (
          <View style={styles.lockCoins}>
            <Entypo name="lock" size={48} style={{fontWeight: "900"}}
              color="#FFFFFF" />
            <Text style={{
              color: "#FFFFFF", fontSize: 16, fontWeight: "bold",
              marginTop: 8
            }}>
              {item.price_num} Unlock
            </Text>
          </View>
        )}
        <View style={styles.overlay}>
          <Text style={styles.name}>{item.role_name}</Text>
          <Text style={styles.description} numberOfLines={2}>{item.description}</Text>
        </View>
      </TouchableOpacity>
    </View>
  );

  const renderFooter = () => {
    if (!loading) return null;
    return (
      <View style={styles.footer}>
        <ActivityIndicator size="large" color="#007AFF" />
      </View>
    );
  };
  
    const payChanges = (state: string)=>{
      setCheckPay({ coin: 50, index: 0, open: false, tips: "Unlock this image with coins" });
      if(state === "success"){
        let { unlock_theme } = userCurrent;
        let copy_theme = [...unlock_theme];
        copy_theme.push( characters[checkPay.index].id );
        PayAPI.updateProfiles(
          dispatch, {unlock_theme: copy_theme}
        );
      }else{
        navigation.navigate("MainTabs", { screen: "Gem"});
      }
    };

  return (
    <View style={styles.container}>
      {error ? (
        <View style={styles.errorContainer}>
          <Text style={styles.errorText}>{error}</Text>
          <TouchableOpacity onPress={() => loadCharacters(true)}>
            <Text style={styles.retryButton}>Retry</Text>
          </TouchableOpacity>
        </View>
      ) : (
        <FlatList
          data={characters}
          renderItem={renderItem}
          keyExtractor={(item) => item.id}
          numColumns={2}
          contentContainerStyle={styles.grid}
          onEndReached={() => { loadCharacters() }}
          onEndReachedThreshold={0.5}
          onRefresh={() => loadCharacters(true)}
          refreshing={ loading }
          ListFooterComponent={renderFooter}
          ListFooterComponentStyle={{ width: "100%" }}
        />
      )}
      
      <PayTipModal
        open={ checkPay.open } setOpen={()=>{
          setCheckPay({...checkPay, open: false});
        }} onChange={payChanges}
        tipText="Unlock this image with coins" delCoins={ checkPay.coin } />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgb(25,27,44)',
  },
  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  errorText: {
    fontSize: 16,
    color: '#ff3b30',
    textAlign: 'center',
    marginBottom: 10,
  },
  retryButton: {
    fontSize: 16,
    color: '#007AFF',
    fontWeight: 'bold',
  },
  footer: {
    paddingVertical: 20,
    alignItems: 'center',
  },
  scrollContainer: {
    padding: 3,
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    paddingTop: 10,
  },
  card: {
    width: COLUMN_WIDTH,
    margin: 5,
    borderRadius: 16,
    backgroundColor: "transparent",
    overflow: 'hidden',
    aspectRatio: 9/16, // Widescreen aspect ratio (16:9)
  },
  image: {
    width: '100%',
    height: '100%',
  },
  touchable: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  overlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    padding: 10,
  },
  name: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  description: {
    color: '#fff',
    fontSize: 12,
    opacity: 0.9,
  },
  lockCoins:{
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
});